const EMPTY_CELL = '-';
const SEPARATOR = ' / ';

/**
 * The backend stores the downloaded portrait as one text, "<case number> / <report date>"
 * (ProgressPortraitFileDownloadMutationAdapter#buildSourceIdentifier), taken at download time.
 * The download log shows the two halves as Portrait ID and Report Date. It splits at the last
 * separator, because the report date is an ISO date and never contains one.
 */
export const splitSourceIdentifier = (sourceIdentifier: string | null): {portraitId: string; reportDate: string} => {
    if (!sourceIdentifier) {
        return {portraitId: EMPTY_CELL, reportDate: EMPTY_CELL};
    }
    const at = sourceIdentifier.lastIndexOf(SEPARATOR);
    const caseNumber = at === -1 ? sourceIdentifier : sourceIdentifier.substring(0, at);
    const reportDate = at === -1 ? '' : sourceIdentifier.substring(at + SEPARATOR.length);
    return {
        portraitId: caseNumber.trim() || EMPTY_CELL,
        reportDate: reportDate.trim() || EMPTY_CELL,
    };
};
